import {
  AfterViewInit,
  Component,
  Directive,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  ViewContainerRef,
  ViewEncapsulation
} from '@angular/core';

import {environment} from '../../../../environments/environment';
import {language} from '../../../language/vn';
import {CommandUtil} from '../../../global/commandutil';
import {DatePipe} from '@angular/common';
import {Sessioncommand} from '../../../global/sessioncommand';
import {BsModalService} from 'ngx-bootstrap/modal';
import {FileMeetingComponent, } from './file.component';
import {ConfirmDialogComponent} from '../../dialog/confirmdialog.component';
import {ToastrService} from 'ngx-toastr';
import {Meeting} from '../../../models/info/meeting';
import {MeetingXuLy} from '../../../models/info/meetingxuly';
import {MeetingFile} from '../../../models/info/meetingfile';
import {MeetingComment} from '../../../models/info/meetingcomment';
import {MeetingService} from '../../../service/info/service-meeting';
import {MeetingFileService} from '../../../service/info/service-meetingfile';
import {MeetingXuLyService} from '../../../service/info/service-meetingxuly';
import {MeetingCommentService} from '../../../service/info/service-meetingcomment';
import {YKTongHopMeetingComponent} from './ykientonghop.component';
import {YKienMeetingComponent} from './ykien.component';
import {ThoiHanMeetingComponent} from './thoihan.component';
import {DanhSachTHMeetingComponent} from './danhsach.component';
import {MoiHopMeetingComponent} from './moihop.component';
import {NavItemService} from '../../../service/staff/service-navitem';
import {DomSanitizer} from '@angular/platform-browser';
@Component({
  selector: 'xulymeeting-detail',
  templateUrl: './xulydetail.component.html',

})
export class XuLyDetailMeetingComponent implements OnInit, AfterViewInit {
  @Input() meetingId: number = 0;
  @Output() backMethod: EventEmitter<string> = new EventEmitter();
  @Output() nextPage: EventEmitter<string> = new EventEmitter();
  @Output() backPage: EventEmitter<string> = new EventEmitter();
  public totalItems: number = 0;
  public currentPage: number   = environment.currentPage;
  public maxSize: number = environment.pageMaxRecord;
  public numPages: number = environment.numberPages;
  public language = language;
  public showAction = true;
  public meetingItem: Meeting = new Meeting();
  public meetingXuLyItem: MeetingXuLy = new MeetingXuLy();
  public meetingFiles: MeetingFile[] = [];
  public meetingXuLyList: MeetingXuLy[] = [];
  public meetingXuLyUser: MeetingXuLy[] = [];
  public meetingCommentList: MeetingComment[]=[];
  public fileLists: Object[]=[];
  public trangThaiHoanThanh: number = environment.hoanthanh;
  public trangThaiChuaPhatBieu: number =environment.chuaphatbieu;
  public maNguoiXuLy: number = Sessioncommand.staffId;
  public chuaPhatBieuList: MeetingXuLy[] = [];
  public daPhatBieuList: MeetingXuLy[] = [];
  public permissionAdmin: boolean = false;
  constructor(
    public meetingService: MeetingService,
    public datepipe: DatePipe,
    public toastr: ToastrService,
    public commandUtil: CommandUtil,
    public meetingFileService: MeetingFileService,
    public meetingXuLyService: MeetingXuLyService,
    public bsModalService: BsModalService,
    public meetingCommentService: MeetingCommentService,
    public navItemService: NavItemService,
    public sanitizer: DomSanitizer
  ) {
  }
  ngAfterViewInit() {

  }
  public thoiHan() {
    const modalEdit = this.bsModalService.show(ThoiHanMeetingComponent);
    (<ThoiHanMeetingComponent>modalEdit.content).edit(
      this.meetingId
    );
    (<ThoiHanMeetingComponent>modalEdit.content).onClose.subscribe(result => {
      this.edit(this.meetingId);
    });

  }
  public changeStatus()
  {
    const modal = this.bsModalService.show(ConfirmDialogComponent);
    (<ConfirmDialogComponent>modal.content).showConfirmationModal(
      language.message,
      language.confirm_hoanthanh_meeting_question,
      language.yes,
      language.no
    );
    (<ConfirmDialogComponent>modal.content).onClose.subscribe(result => {
      if (result === true) {
        this.meetingXuLyService.changeStatus(this.meetingId, environment.hoanthanh, Sessioncommand.staffId).subscribe(
          {
            next: (data) => {
              if(data !== -1)
              {
                this.toastr.success(language.change_hoanthanh_meeting_success, language.message);
                Sessioncommand.giaiQuyetSuVuStatus = 0;
                Sessioncommand.notification = true;
              }else
                this.toastr.warning(language.error_message_meeting_success, language.message);

              this.edit(this.meetingId);
            },
            error: error => {
              this.toastr.error(language.error, language.message);
            }
          }
        );
      }
    });
  }
  toggleDropdown($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();
  }
  public edit(id: number)
  {
    this.meetingId = id;
    this.meetingService.getById(id).subscribe(x => this.meetingItem = x);
    this.meetingXuLyService.getByMaVBAndMXL(id, Sessioncommand.staffId).subscribe(data => {
      this.meetingXuLyItem = data;
    });
    this.meetingFileService.findAllByMeetingId(id).subscribe( x => this.meetingFiles = x);
    this.loadComment(this.meetingId);
    this.meetingXuLyService.findByMaYeuCau(id).subscribe( data => {this.meetingXuLyList = data;
      this.meetingXuLyUser = this.meetingXuLyList.filter(x=> x.maNguoiXuLy !== this.maNguoiXuLy);
      this.daPhatBieuList = this.meetingXuLyList.filter( x => x.trangThai === environment.daphatbieu);
      this.chuaPhatBieuList = this.meetingXuLyList.filter( x => x.trangThai === environment.chuaphatbieu);
    });
  }
  ngOnInit(): void {
    this.edit(this.meetingId);
    this.navItemService.checkPermissionByCode(Sessioncommand.staffId,"0001", true).subscribe(
      x => { this.permissionAdmin = x> 0? true: false;
      }
    );

  }
  public showXuLy(meetingList: MeetingXuLy[])
  {
    const modalEdit = this.bsModalService.show(DanhSachTHMeetingComponent, {class: 'modal-lg'});
    (<DanhSachTHMeetingComponent>modalEdit.content).edit(
      meetingList
    );
    (<DanhSachTHMeetingComponent>modalEdit.content).onClose.subscribe(result => {
    });
  }
  public loadComment(id: number)
  {
    this.meetingCommentService.getCountByKeyword(id, Sessioncommand.staffId).subscribe( data => this.totalItems = data);
    this.meetingCommentService.findAllByPaging(id, Sessioncommand.staffId, this.currentPage, this.maxSize).subscribe( data => this.meetingCommentList = data);
  }
  public yKienTongHop() {
    const modalEdit = this.bsModalService.show(YKTongHopMeetingComponent, {class: 'modal-lg'});
    (<YKTongHopMeetingComponent>modalEdit.content).edit(
      this.meetingId
    );
    (<YKTongHopMeetingComponent>modalEdit.content).onClose.subscribe(result => {
    });

  }
  public yKienXuLy(replyId: number) {
    const modalEdit = this.bsModalService.show(YKienMeetingComponent, {class: 'modal-lg'});
    (<YKienMeetingComponent>modalEdit.content).edit(
      this.meetingId, replyId
    );
    (<YKienMeetingComponent>modalEdit.content).onClose.subscribe(result => {
      this.edit(this.meetingId);
    });

  }
  public moiHop() {
    const modalEdit = this.bsModalService.show(MoiHopMeetingComponent, {class: 'modal-lg'});
    (<MoiHopMeetingComponent>modalEdit.content).edit(
      this.meetingId
    );
    (<MoiHopMeetingComponent>modalEdit.content).onClose.subscribe(result => {
      this.edit(this.meetingId);
    });

  }
  public xuLyLai()
  {
    const modal = this.bsModalService.show(ConfirmDialogComponent);
    (<ConfirmDialogComponent>modal.content).showConfirmationModal(
      language.message,
      language.message_xulymeeting_question,
      language.yes,
      language.no
    );
    (<ConfirmDialogComponent>modal.content).onClose.subscribe(result => {
      if (result === true) {
        this.meetingService.resetMeeting(this.meetingId, environment.dangxuly).subscribe(
          {
            next: (data) => {
              this.toastr.success(language.message_xulymeeting_success, language.message);
              Sessioncommand.giaiQuyetSuVuStatus = 0;
              Sessioncommand.notification = true;
              this.edit(this.meetingId);
            },
            error: error => {
              this.toastr.error(language.error, language.message);
            }
          }
        );
      }
    });
  }
  public thamKhao()
  {
    const modal = this.bsModalService.show(ConfirmDialogComponent);
    (<ConfirmDialogComponent>modal.content).showConfirmationModal(
      language.message,
      this.meetingItem.choThamKhao === 1? language.message_not_thamkhao_question: language.message_thamkhao_question,
      language.yes,
      language.no
    );
    (<ConfirmDialogComponent>modal.content).onClose.subscribe(result => {
      if (result === true) {
        this.meetingService.changeThamKhao(this.meetingId, (this.meetingItem.choThamKhao === 1? 0 : 1) ).subscribe(
          {
            next: (data) => {
              this.toastr.success(this.meetingItem.choThamKhao === 1? language.message_not_thamkhao_success: language.message_thamkhao_success, language.message);
              this.edit(this.meetingId);
            },
            error: error => {
              this.toastr.error(language.error, language.message);
            }
          }
        );
      }
    });
  }
  public thayFile(id: number) {
    const modalEdit = this.bsModalService.show(FileMeetingComponent, {class: 'modal-lg'});
    (<FileMeetingComponent>modalEdit.content).edit(
      id
    );
    (<FileMeetingComponent>modalEdit.content).onClose.subscribe(result => {
      this.loadComment(this.meetingId);
    });

  }
  pageChanged(event: any): void {
    this.currentPage = event.page;
    this.loadComment(this.meetingId);
  }




}

